import React, { useState, useEffect, useContext } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import { useTranslation } from "react-i18next";
import axios from "axios";
import ListAdminButtons from "../Common/ListAdminButtons";
import { useHistory } from "react-router-dom";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { AuthContext } from "../../Contexts/AuthContext";
import { roles } from "../../Config/Roles";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import Tooltip from "../../Components/Common/Tooltip";
import SpinnerLoading from "../Common/SpinnerLoading";
import { userServices } from "../../Services/user.service";

const UsersTab = (props) => {
  const { t: translator } = useTranslation();
  const { roleId, userId } = useContext(AuthContext);
  const { cashier, accountant, owner } = roles;
  const { locTab, isMobile, locStore, locName, locTenant } =
    useContext(GlobalContext);
  const [data, setData] = useState([]);
  const [showUsers, setShowUsers] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [showInfoModal, setShowInfoModal] = useState(false);
  const [usersByTenant, setUsersByTenant] = useState([]);
  const [userGuid, setUserId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const history = useHistory();

  const { register, handleSubmit, errors } = useForm();

  useEffect(() => {
    if (locTab === "users") {
      setIsLoading(true);
      axios
        .get(props.url)
        .then((res) => {
          setData(res.data.data);
          setIsLoading(false);
        })

        .catch((err) => console.log(err.response));
    }
  }, [locTab]);

  const handleOnSelect = (row, isSelect) => {
    let newArray = selectedItems;
    if (isSelect) {
      newArray = [];
      newArray.push(row.userId);
      setSelectedItems(newArray);
    } else {
      newArray = newArray.filter((p) => p !== row.userId);
      setSelectedItems(newArray);
    }
  };

  function actionFormatter(cell, row) {
    return (
      <div className="action">
        <label className="labelCont">
          <input
            name="userId"
            type="radio"
            checked={selectedItems.find((x) => x === row.userId)}
            onChange={(e) => handleOnSelect(row, e.target.checked)}
          />
          <span className="checkmark"></span>
        </label>
      </div>
    );
  }

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      if (e.target.cellIndex) {
        history.push(`/users/${row.userId}`);
      }
    },
  };

  function roleFormatter(cell) {
    return translator(cell);
  }

  const { SearchBar } = Search;
  const columns = [
    {
      dataField: "userId",
      text: "",
      headerStyle: (colum, colIndex) => {
        return { width: "50px", textAlign: "center" };
      },

      formatter: actionFormatter,
      hidden: [cashier, accountant].includes(Number(roleId)) ? true : false,
    },
    {
      dataField: "realName",
      text: translator("Users-View-TableHeader-FullName"),
    },
    {
      dataField: "personalIdentificationNumber",
      text: "OIB",
      hidden: Boolean(isMobile),
    },
    {
      dataField: "loginName",
      text: translator("Users-View-TableHeader-Username"),
      hidden: Boolean(isMobile),
    },
    {
      dataField: "roleName",
      text: translator("Users-View-TableHeader-RoleName"),
      hidden: Boolean(isMobile),
      formatter: roleFormatter,
    },
    {
      dataField: "email",
      text: "Email",
      headerStyle: (colum, colIndex) => {
        return { width: "200px", textAlign: "center" };
      },
      hidden: Boolean(isMobile),
    },
    {
      dataField: "phone",
      text: translator("Users-View-TableHeader-PhoneNumber"),
      hidden: Boolean(isMobile),
    },
  ];
  const options = { custom: true, totalSize: data.length, sizePerPage: 8 };

  const populateUsers = () => {
    userServices
      .getUsersByTenant(`tenant/${props.tenantId}/users`)
      .then((res) => {
        let myArray = res.data.data.filter(
          (ar) => !data.find((rm) => rm.userId === ar.userId)
        );

        setUsersByTenant(myArray);
        setShowUsers(true);
      })
      .catch((err) => console.log(err.response));
  };
  const handleToAdd = () => {
    props.tenantId != null ? populateUsers() : history.push("/adduser");
  };

  const handleAddUserToStore = (userId) => {
    let id = userId.userId;

    userServices
      .addUserToStore(id, locStore)
      .then((res) => {
        setShowUsers(false);
        axios
          .get(props.url)
          .then((res) => setData(res.data.data))
          .catch((err) => console.log(err.response));
      })
      .catch((err) => console.log(err));
  };

  const handleDeleteUserFromStore = () => {
    locName == "tenants"
      ? userServices
        .deleteUserFromTenant(selectedItems[0], locTenant)
        .then((res) => {
          setShowDeleteModal(false);
          axios
            .get(props.url)
            .then((res) => setData(res.data.data))
            .catch((err) => console.log(err.response));
        })
        .catch((err) => console.log(err))
      : userServices
        .deleteUserFromStore(selectedItems[0], locStore)
        .then((res) => {
          setShowDeleteModal(false);
          axios
            .get(props.url)
            .then((res) => setData(res.data.data))
            .catch((err) => console.log(err.response));
        })
        .catch((err) => console.log(err));
  };

  return (
    <div className="p-2">
      <div className="container-fluid p-0">
        <div className="card-body pl-0 mb-4">
          <ToolkitProvider
            keyField="userId"
            data={data}
            columns={columns}
            search
          >
            {(props) => (
              <div>
                <SearchBar
                  placeholder={translator("Users-Tab-SearchName")}
                  {...props.searchProps}
                />{" "}
                <Tooltip text={translator("Tabs-Search")} />
                <ListAdminButtons
                  selectedItemsLength={selectedItems.length}
                  handleToAdd={
                    [cashier, accountant].includes(Number(roleId))
                      ? null
                      : handleToAdd
                  }
                  handleDelete={() => {

                    selectedItems[0] != userId
                      ? setShowDeleteModal(true)
                      : setShowInfoModal(true);
                  }}
                />
                <PaginationProvider pagination={paginationFactory(options)}>
                  {({ paginationProps, paginationTableProps }) => (
                    <div>
                      {isLoading && (
                        <div className="dashboard-card-spinner">
                          <SpinnerLoading />
                        </div>
                      )}
                      {!isLoading && (
                        <BootstrapTable
                          keyField="userId"
                          data={data}
                          loading
                          columns={columns}
                          classes={"table-sm"}
                          rowEvents={rowEvents}
                          rowClasses="boostrap-table-row"
                          noDataIndication={translator("No-Data")}
                          {...paginationTableProps}
                          {...props.baseProps}
                        />
                      )}

                      <PaginationListStandalone {...paginationProps} />
                    </div>
                  )}
                </PaginationProvider>
              </div>
            )}
          </ToolkitProvider>
          <Modal show={showUsers} backdrop="static" keyboard={false} centered>
            <Modal.Header>
              <Modal.Title>{translator("StoreTab-AddUserToStore")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="form-group col-sm-12">
                <p>{translator("Breadcrumb-Users")}:</p>
                {usersByTenant && usersByTenant.length > 0 ? (
                  <select
                    placeholder={translator("SelectStoreTag")}
                    name="userId"
                    className="form-control"
                    ref={register({
                      validate: (value) => value !== "-1",
                    })}
                    onChange={(event) => {
                      setUserId(event.target.value);
                    }}
                  >
                    {usersByTenant &&
                      usersByTenant.map((e) => (
                        <option value={e.userId}>{e.realName}</option>
                      ))}
                  </select>
                ) : (
                  <p>{translator("No-Data")}</p>
                )}

                {errors.userId && errors.userId.type === "validate" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button
                className="btn btn-outline-secondary"
                onClick={() => setShowUsers(false)}
              >
                {translator("General-Close")}
              </button>
              <button
                onClick={handleSubmit(handleAddUserToStore)}
                type="button"
                className="btn btn-primary"
              >
                {translator("ListAdminButtons-Add")}
              </button>
            </Modal.Footer>
          </Modal>
          <Modal
            show={showDeleteModal}
            backdrop="static"
            keyboard={false}
            centered
          >
            <Modal.Header>
              <Modal.Title>
                {locName == "tenants"
                  ? translator("ModalTitle-DeleteUserFromTenant")
                  : translator("ModalTitle-DeleteUserFromStore")}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {locName == "tenants"
                ? translator("ModalText-DeleteUserFromTenant")
                : translator("ModalText-DeleteUserFromStore")}
            </Modal.Body>
            <Modal.Footer>
              <button
                className="btn btn-outline-secondary"
                onClick={() => setShowDeleteModal(false)}
              >
                {translator("General-Close")}
              </button>
              <button
                onClick={handleSubmit(handleDeleteUserFromStore)}
                type="button"
                className="btn btn-primary"
              >
                {translator("General-Delete")}
              </button>
            </Modal.Footer>
          </Modal>
          <Modal
            show={showInfoModal}
            backdrop="static"
            keyboard={false}
            centered
          >
            <Modal.Header>
              <Modal.Title>Greška</Modal.Title>
            </Modal.Header>
            <Modal.Body>Nije moguće obrisati sam sebe.</Modal.Body>
            <Modal.Footer>
              <button
                className="btn btn-outline-secondary"
                onClick={() => setShowInfoModal(false)}
              >
                {translator("General-Close")}
              </button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default UsersTab;
